import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/brands.css";
import { AiFillCar } from "react-icons/ai";
import { ColorRing } from "react-loader-spinner";
import { server } from "../server";
import CarCard from "./CarCard";

const CarsHome = () => {
  const [cars, setcars] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAllcars = async () => {
    try {
      const data = await fetch(`${server}/api/car/getAll-car`, {
        method: "GET",
        headers: { "Content-type": "application/json" },
      });
      const data_ = await data.json();
      setcars(data_?.cars?.reverse());
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(true);
    }
  };

  useEffect(() => {
    getAllcars();
  }, []);

  return (
    <>
      <div className="brand_wrapper" id="cars">
        <div className="col-12 text-center">
          <p className="brand_subtitle">
            Explore an array of exciting new Cars !
          </p>
          <h2 className="brand_title">Latest Cars showcase</h2>
        </div>
      </div>
      {loading ? (
        <div className="h-100 d-flex align-items-center justify-content-center">
          <ColorRing
            visible={true}
            colors={[
              "#000435",
              "rgb(14 165 233)",
              "rgb(243 244 246)",
              "#000435",
              "rgb(14 165 233)",
            ]}
          />
        </div>
      ) : (
        <div className="container">
          <div className="row" style={{ marginTop: "-40px" }}>
            {cars.slice(0, 8).map((p) => (
              <div className="col-md-12 col-lg-3 mb-3 mb-lg-0 my-3">
                <CarCard p={p} />
              </div>
            ))}
          </div>
          <div className="col-12 text-center my-5">
            <Link
              to="/cars"
              className="btn btn-lg text-white"
              style={{ backgroundColor: "blueviolet" }}
            >
              View More <AiFillCar size={25} />
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default CarsHome;
